import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    email: '',
    purpose: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Using FormSubmit AJAX endpoint for immediate functionality
    try {
      const response = await fetch("https://formsubmit.co/ajax/yogitaturture2@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          contact: formData.contact,
          message: formData.purpose,
          _subject: "New Inquiry from Shree Photo Studio Website"
        }),
      });

      const result = await response.json();
      if (result.success === "true") {
        setSubmitStatus('success');
        setFormData({ name: '', contact: '', email: '', purpose: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-header reveal-scale">
          <h1 className="say-hi">Say Hi !</h1>
        </div>

        <div className="contact-main-grid">
          <div className="contact-left">

            <form className="contact-form reveal stagger-2" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="HI, WHAT'S YOUR NAME?"
                  className="contact-input"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="contact"
                  placeholder="YOUR CONTACT NUMBER"
                  className="contact-input"
                  value={formData.contact}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="DROP YOUR EMAIL ID"
                  className="contact-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="purpose"
                  placeholder="WHAT CAN WE CLICK FOR YOU?"
                  className="contact-input"
                  value={formData.purpose}
                  onChange={handleChange}
                />
              </div>
              <button 
                type="submit" 
                className={`submit-btn ${isSubmitting ? 'loading' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'SENDING...' : 'SUBMIT'}
              </button>
              
              {submitStatus === 'success' && (
                <p className="status-msg success">✨ Message sent successfully! We'll be in touch soon.</p>
              )}
              {submitStatus === 'error' && (
                <p className="status-msg error">❌ Something went wrong. Please try again or email us directly.</p>
              )}
            </form>
          </div>

          <div className="contact-right">
            <img 
              src="https://images.unsplash.com/photo-1547517023-7ca0c162f816?q=80&w=1000&auto=format&fit=crop" 
              alt="Macarons Collage" 
              className="collage-img img-macarons reveal-right stagger-1" 
            />
            <img 
              src="https://images.unsplash.com/photo-1541913080-214307cd8bd9?q=80&w=1000&auto=format&fit=crop" 
              alt="Silhouette" 
              className="collage-img img-child reveal-right stagger-2" 
            />
            <img 
              src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=1000&auto=format&fit=crop" 
              alt="Wedding Cake" 
              className="collage-img img-couple reveal-right stagger-3" 
            />
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
